var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ml-loading-container"},[_c('div',{staticClass:"balls"},[_c('div'),_c('div'),_c('div')])])}]

export { render, staticRenderFns }